import { MotionProps } from "framer-motion";
import { PropsWithChildren } from "react";
import { GenericPageNavSection } from "./generic";

const defaultViewportOptions = {
  amount: "all",
} as const;
type PageNavSectionProps = {
  id: string;
  className?: string;
  anchorClassName?: string;
  onViewLeave: (sectionName: string) => void;
  onViewEnter: (sectionName: string) => void;

  onSectionRegister: (sectionName: string) => void;
  onSectionUnregister: (sectionName: string) => void;
  viewportOptions?: MotionProps["viewport"];
};
export const PageNavSection = (
  props: PropsWithChildren<PageNavSectionProps>,
) => {
  return <GenericPageNavSection {...props} />;
};
